import { styled } from '@mui/material';

export const ImageInput = styled('div')(() => ({
  height: '100%',
  width: '20%',
  minWidth: 120,
  marginLeft: 8,
}));

export const TextAreaWrapper = styled('div')(({ theme }) => ({
  display: 'flex',

  textarea: {
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    padding: '10px 26px 10px 12px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    fontSize: 16,
    fontFamily: 'Public Sans, sans-serif',
    '&:focus': {
      borderRadius: 4,
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      outline: 'none',
    },
    placeholder: {
      fontSize: 16,
    },
  },
}));

export const ImageUploadArea = styled('div')(({ theme }) => ({
  height: 170,
  width: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: 4,
  backgroundColor: theme.palette.background.paper,
}));

export const ImageArea = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  height: '100%',
  width: '100%',

  img: {
    objectFit: 'contain',
  },

  '.image-actions': {
    visibility: 'hidden',
  },

  '&:hover': {
    '.image-actions': {
      visibility: 'visible',
    },
  },
}));

export const ImageActions = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',

  '&:hover': {
    background: 'rgba(0, 0, 0, 0.2)',
  },
}));

export const ChipInput = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 45,
  width: '100%',
  padding: '0px 16px',
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: 4,
  backgroundColor: theme.palette.background.paper,
}));
